module.exports = __webpack_public_path__ + "img/waerme-img4v2.a803ef1a.png";